import { render, staticRenderFns } from "./403.vue?vue&type=template&id=5931cfc0"
var script = {}
import style0 from "./403.vue?vue&type=style&index=0&id=5931cfc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports